// Splits a displayed challenge into its blocks, keeping the index of every character in the displayed string
// (spaces included, the convention of the engine solution). The block sizes come from the convention parameters
// (`blocks`, e.g. [4,4,4,4], [60], [3,3]) when they describe this string; otherwise the string is split on spaces.
// Never assumes a length: every family has its own shape.

export const NOWRAP_MAX = 16;

const fromSizes = (content, sizes) => {
    if (!Array.isArray(sizes) || sizes.length === 0) return null;
    if (!sizes.every((size) => Number.isInteger(size) && size > 0)) return null;
    const total = sizes.reduce((sum, size) => sum + size, 0) + sizes.length - 1;
    if (total !== content.length) return null;
    const blocks = [];
    let start = 0;
    for (let i = 0; i < sizes.length; i += 1) {
        const text = content.slice(start, start + sizes[i]);
        if (text.indexOf(' ') !== -1) return null;
        if (i < sizes.length - 1 && content[start + sizes[i]] !== ' ') return null;
        blocks.push({ start, text });
        start += sizes[i] + 1;
    }
    return blocks;
};

const fromSpaces = (content) => {
    const blocks = [];
    let start = null;
    for (let i = 0; i <= content.length; i += 1) {
        const isSpace = i === content.length || content[i] === ' ';
        if (!isSpace && start === null) start = i;
        if (isSpace && start !== null) {
            blocks.push({ start, text: content.slice(start, i) });
            start = null;
        }
    }
    return blocks;
};

export const splitBlocks = (content, sizes) => {
    if (typeof content !== 'string' || content.length === 0) return [];
    return fromSizes(content, sizes) || fromSpaces(content);
};

// Placeholder blocks (loading state), drawn from the block sizes only.
export const placeholderBlocks = (sizes) =>
    (Array.isArray(sizes) ? sizes : []).filter((size) => Number.isInteger(size) && size > 0 && size <= 200);
